import styled from 'styled-components';
 
export const AxisWrapperContainer = styled.div<{gridRows?: string, gridCols?: string}>`
  display: grid;
 
  gap: .5em;
 
  grid-template-columns: ${({gridCols}) => gridCols || '1fr'};
  grid-template-rows: ${({gridRows}) => gridRows || '1fr'};


  [data-id='axis-label-right'] {
    grid-column: 3;
    grid-row: 1;
    margin-left: .5em;
  }

  [data-id='axis-label-left'] {
    grid-column: 1;
    grid-row: 1;
    margin-right: .5em;
  }

  [data-id='axis-label-top'] {
    grid-column: 2;
    grid-row: 1;
    margin-bottom: .5em;
  }

  [data-id='axis-label-bottom'] {
    grid-column: 2;
    grid-row: 2;
 
  }

  .center-chart-area {
    position: relative;
    grid-column: 2;
    grid-row: 1;
    z-index: 1;
  }

  .axis-label--bottom {
    padding-top: 8px;
  }

  .axis-label {
    text-align: center;
    min-height: 1.5em;
    min-width: 1.5em;
    position: relative;
    margin: 0;
    font-weight: 500;
    font-size: .8em;
    z-index: 0;
    text-transform: capitalize;
    
    &.axis-label--side {
      .axis-label-inner {
        min-width: max-content;
        position: absolute;
        transform: rotate(-90deg);
        transform-origin: left center;
        left: 50%;
        top: 50%;
      }
    }
  }
`
 
export const ResponsiveChartContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  font-size: 1em;
  display: grid; 
  gap: 0.5em;
  container-size: size;
 
 
  grid-template-columns: 4em 1fr 1em;
  grid-template-rows: 1em 1fr 3em; 

  .min-max-container {     
     
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-rows: inherit;
    grid-template-columns: inherit;
  }

  .grid-axis {
    position: relative;
    &.outer.before {  grid-column: 1; grid-row: 2;  }
    &.outer.after { grid-column: 3; grid-row: 2; }
    &.inner.before { grid-column: 1; grid-row: 1; }
    &.inner.after { grid-column: 1; grid-row: 3;  }
    &.center {
      grid-column: 2;
      grid-row-start: span 3;
      grid-template-rows: inherit;
      grid-template-columns: 1fr;
    }
  }

  .min-max-container { 
    grid-column: 1;
    grid-row-start: span 3;
  }

  &.is-overflowing {
    .grid-scroll {
      overflow-x: auto; 
      overflow-y: hidden;
    }
  }


  &.vertical {


    &.is-overflowing {
      .grid-scroll {
        overflow-y: auto; 
        overflow-x: hidden;
      }
    }

    .grid-axis {
      position: relative;
      &.outer.before { grid-column: 2; grid-row: 1; }
      &.outer.after { 
        grid-column: 2; grid-row: 3; 
        .tick-inner {
      transform: translateX(-25%)
    }
        }
      &.inner.before { 
      grid-column: 1; grid-row: 1; 
      .tick-inner {
      transform: translateX(-10px);
    }
      
      }
      &.inner.after { grid-column: 3; grid-row: 1; }
      &.center {
        display: grid;
        grid-row: 2;
        grid-column: 1 / span 3;
        grid-template-rows: 1fr;
        grid-template-columns: inherit;
      }
    }

    .min-max-container { 
      grid-template-columns: inherit;
      grid-template-rows: 1fr;
      grid-row: 1;
      grid-column: 1 / span 3;
    }

    .grid-scroll {
      grid-template-columns: inherit;
      grid-template-rows: 1fr;
      
    }

    

  }


  

 
  .grid-scroll {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: -10px;
    display: grid;
    grid-template-rows: inherit;
    grid-template-columns: inherit;
    overflow:hidden;
    padding: 0 1em;
  }
  

  overflow: hidden;

  &[data-init="false"] {
    visibility: hidden;
    overflow: hidden!important;
    max-width: 100%;
    
    
    .bar { 
      opacity: 0;
      transition: all 0s; 
    }
  }

  &[data-init="true"] {
  overflow: visible;

    .bar {
      opacity: 1;
    }
  }

  

 


  [data-id='chart-tooltip'] { display: none;}
  &.is-hovered {
    [data-id='chart-tooltip'] { display: block; }
  }
  
  svg.generated-chart-svg-container { overflow: visible; }


  


  .data-point {
    transition: opacity 0.2s ease;
    &.is-filtered {
      scale: 0;
      opacity: 0!important;
    }
  }

  .line-path {
    transition: opacity 0.2s ease;
    &.is-filtered {
      scale: 0;
      opacity: 0!important;
    }
  }

  .chart-area-sizer { 

    
   
    min-height: 100px; 
    height: 100%;
    max-widgth: 100%;
  }

  .data-points-container {
    grid-column: 1;
    grid-row: 1;
  }

  .grid-col {
    display: grid;
    grid-gap: inherit;
    grid-template-rows: inherit;
    grid-template-columns: 1fr;
     
  }

   .grid-row {
      display: grid;
      grid-gap: inherit;
      grid-template-rows: 1fr;
      grid-template-columns: inherit;
      grid-template-areas:
        'left center right'
      ;
  }

  .grid-left { grid-area: left; }
  .grid-top { grid-area: top; }
  .grid-bottom { grid-area: bottom; }
 
  .grid-right { grid-area: right; }
 

 
 
 
  .rel-pos { 
    &.full {
      width: 100%;
      height: 100%;
      max-width: 100%;
      max-height: 100%;
    }
    position: relative; 
  }

  .abs-pos { 
    position: absolute; 
    &.full {
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
    }
  }

  .axis {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    transform: translate(0);
    font-size: .9em;
    &.left,
    &.right {
      .tick-inner {  
        padding-left: 0;
        padding-right: 0;
      }
    }
    

    &.left {  
      .tick-mark { 
        text-align: right; 
        transform: translate(0, -50%);
        right: 0;
      }
    }

    &.bottom {
      top: 0;
      
      .tick-mark {
        top: 0;
        display: inline-flex;
        align-items: center;
        text-align: center;
        
        .tick-inner {
          transform: translateX(-50%);
        }

        .tick-mark-wrapper {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: .25em;
          
          span {
            display: block;
          }
        }
          
      }
    }
  }
  
  

 

  


  

  
`
 
/* 

transform: rotate(-90deg) ;
        transform-origin: right center;
 justify-content: flex-end;
        */